import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// I5 (trust track): public legal pages, outside the app shell and without sign-in.
const legal = () => import('./legal-page');
export const legalRoutes: RouteObject[] = [
  { path: '/legal', lazy: page(legal, (m) => m.LegalIndexPage) },
  { path: '/legal/:slug', lazy: page(legal, (m) => m.LegalPage) },
];
